import Api from './Api'

class AnnualSummaryService {
    getBlocks = async () => {
        return await Api().get(`annual-summary-blocks`)
    }

    getBlockTables = async ({ blockId }) => {
        return await Api().get(`annual-summary-blocks/${blockId}`)
    }

    saveBlockTable = async ({ blockId, data, tableId }) => {
        return await Api().put(`annual-summary-blocks/${blockId}/${tableId}`, data)
    }

    deleteBlockTable = async ({ blockId, tableId }) => {
        return await Api().delete(`annual-summary-blocks/${blockId}/${tableId}`)
    }

    recalculateAnnualSummary = async ({ tableId }) => {
        return await Api().post(`annual-summary/fetch/${tableId}`)
    }

    saveBlockTablesSortOrder = async ({ blockId, data }) => {
        return await Api().put(`annual-summary-blocks/${blockId}/sort-order`, data)
    }

    sendEmail = async () => {
        return await Api().put(`annual-summary/email`)
    }
}

export default new AnnualSummaryService()
